import { render } from "./fixbox.vue?vue&type=template&id=724ba472&scoped=true"
import script from "./fixbox.vue?vue&type=script&lang=js"
export * from "./fixbox.vue?vue&type=script&lang=js"

import "./fixbox.vue?vue&type=style&index=0&id=724ba472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724ba472"]])

export default __exports__